import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, ImageAvatar, SquareChip, TagsArray, Text, useSettings } from 'app/main/components';
import { DateRangeSquareChip } from 'app/main/components/list-items';
import buttons from './TicketsButtons';

export default function TicketsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.tick_user_assigned_uid}
			avatar={props.model.user_assigned_avatar}
			initials={props.model.tick_title_initials}
			labelBadge={props.model.tist_title_initials}
			labelBadgeTooltip={props.model.tist_title}
			badgeColor={props.model.tist_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 600 ? 8 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.tick_warning_desc && (
								<Tooltip title={props.model.tick_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.tick_blocked_desc && (
								<Tooltip title={props.model.tick_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'tickets', uid: props.model.tick_uid }}
							>
								{props.model.comp_title && `${props.model.comp_title} - `}
								{props.model.tick_title}
							</Text>
						</Grid>
						{/* TYPE */}
						<Grid>
							{props.model.tity_title && (
								<SquareChip label={props.model.tity_title} backgroundColor={props.model.tity_color} />
							)}
						</Grid>
						{/* DATE FROM - TO */}
						<Grid>
							<DateRangeSquareChip from={props.model.tick_d_from} to={props.model.tick_d_to} />
						</Grid>
						{/* TAGS */}
						<Grid>
							<TagsArray tags={props.model.tick_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={4}>
						<Grid container>
							{/* INTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.tick_user_assigned_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_INTUSER')}
								>
									{props.model.user_assigned_title}
								</ButtonLink>
							</Grid>
							{/* EXTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.tick_user_assigned_2_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_EXTUSER')}
								>
									{props.model.user_assigned_2_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
